import React from 'react';
import { useHistory } from 'react-router-dom';
import { stringify } from 'query-string';

import { DropdownMenuItem, DropdownMenuSeparator } from '@dashboard/components/ui/dropdown-menu';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

type ViewInAdminMenuItemProps = {
  pageId: string;
};

const ViewInAdminMenuItem = ({ pageId }: ViewInAdminMenuItemProps) => {
  const { isAdmin } = useAuth();
  const history = useHistory();

  if (!isAdmin) return null;

  // Searching the admin pages list by _id resolves to this page's single row.
  const search = stringify({ search: pageId, sortBy: 'createdAt', sortDirection: -1 });

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuItem onSelect={() => history.push(`/admin/pages?${search}`)}>
        View in admin
      </DropdownMenuItem>
    </>
  );
};

export default ViewInAdminMenuItem;
